import { Action } from "redux";

export const GET_SUBSCRIPTION_LIST_FOR_USER_FAIL =
  "SUBSCRIPTION:GET_SUBSCRIPTION_LIST_FOR_USER_FAIL";

export interface GetSubscriptionListForUserFail extends Action {
  type: typeof GET_SUBSCRIPTION_LIST_FOR_USER_FAIL;
  organizationKeyName: string;
  userId: number;
}

export const getSubscriptionListForUserFail = (
  organizationKeyName: string,
  userId: number
): GetSubscriptionListForUserFail => ({
  type: GET_SUBSCRIPTION_LIST_FOR_USER_FAIL,
  organizationKeyName,
  userId,
});
